import { render, staticRenderFns } from "./AjanlatAdatokB13_V0.vue?vue&type=template&id=1860b2fb&"
import script from "./AjanlatAdatokB13_V0.vue?vue&type=script&lang=js&"
export * from "./AjanlatAdatokB13_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports